import { DropzoneFile } from 'components/Dropzone/utils';
import { ObjectValues } from 'types';
import { User } from './User';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import { LeadNdaProps, SoftSignal } from './Lead';
import { EnquiryQuestionType } from 'router/subrouters/Dash/subrouters/Business/components/EnquirySlider/utils';
import { UploadedFile } from './File';
import { ReactionType } from './Reactions';
import { DealRoom } from './DealRoom';
import { Listing } from './Listing';

export type SessionType = {
  _id: string;

  isClosed?: boolean;

  isDirectMessage?: boolean; // user - user chat, no deal

  // isDirectMessage === true
  interlocutor?: User;

  // isDirectMessage === false
  isExternalCommunication?: boolean; // true for BM
  deal?: DealRoom;
  isRepresentingSellSide?: boolean; // true if user is sell side member or isExternalCommunication === true
  sellRepresentative?: { companyName?: string; companyLogo?: DropzoneFile };
  sellRepresentatives?: User[];
  buyRepresentatives?: User[];

  isGroupChat: boolean;
  // 1 on 1
  leadId?: string;
  leadWithdrawnInterest?: boolean;
  manuallySetNDAStatus?: boolean;

  // Group
  groupName?: string; // DR buy side group name
  isArchivedAfterMerging?: boolean; // true when groupes are merged, also isClosed became true

  enquiryQuestions: EnquiryQuestionType[];
  dataRoomNodes: DataRoomNode[];

  hasUnreadMessages: boolean;
  latestMessageAt: Date;
} & LeadNdaProps;

export type UserConnection = {
  _id: string;

  session: SessionType;
};

export type MessageType = {
  _id: string;

  sessionId: string;

  isSentBySellRepresentative?: boolean;
  sentBy?: User;

  text: string;

  createdAt?: string;
  updatedAt?: string;

  isDeleted?: boolean;

  isInterestContext?: boolean;

  // for sharing listing via chat
  isShareListingMessage?: boolean;
  listing?: Partial<Listing>;

  files: MessageFileType[];
  softSignal?: SoftSignal;
  dataRoomNodeId?: string;
  dataRoomNode?: DataRoomNode;
  dataRoomNodeName?: string;
  isPulseCheck?: boolean;

  seenBy: MessageSeenBy[];

  reactions: MessageReaction[];

  showDate?: string;
};

export type MessageSeenBy = {
  userId: string;
  seenAt: Date;
  isSellSide: boolean;
};

export type MessageReaction = {
  userId: string;
  reaction: ReactionType;
  isSellSide: boolean;
};

export type MessageFileType = DropzoneFile & {
  chatSessionFileId?: string;
};

export type ChatSessionFile = UploadedFile & {
  sessionId: string;
};

export const MESSAGE_LOCATION = {
  MESSAGING_PAGE: 'Messaging page',
  LEADS_PAGE: 'Leads page',
  DATA_ROOM: 'Data Room',
} as const;

export type MessageLocation = ObjectValues<typeof MESSAGE_LOCATION>;
